import { PackageVariantClosedPlusIcon } from './PackageVariantClosedPlusIcon';

/**
 * author: Ferenc Szabo
 * id 749AB237-2B69-4BB9-9B2D-6F22B1F85D50
 * name package-variant-closed-plus
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-closed-plus.svg
 * tags
 */
export const BoxVariantClosedPlusIcon = PackageVariantClosedPlusIcon;
export default BoxVariantClosedPlusIcon